export const usersField = [
  {
    name: "firstName",
    label: "First Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "lastName",
    label: "Last Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "email",
    label: "Email *",
    type: "text",
    gridColumn: "span 2",
  },
  {
    name: "phone",
    label: "Phone *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "username",
    label: "Username *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },

  {
    name: "idno",
    label: "National Id *",
    type: "number",
    gridColumn: "span 2",
    required: true,
  },
];
export const PerfomanceFields = [
  {
    name: "collectionrate",
    label: "Collection Rate (%)",
    type: "number",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "par",
    label: "Portfolio At Risk (%) *",
    type: "number",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "LoanCount",
    label: "Loan Count *",
    type: "number",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "loanamount",
    label: "Loan Amount *",
    type: "number",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "CustomerRetention",
    label: "Customer Retention Rate (%) *",
    type: "number",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "LogbookLoans",
    label: "LogBook Loans (Optional)",
    type: "number",
    gridColumn: "span 2",
    required: false,
  },
  {
    name: "checkoffloans",
    label: "Check Off Loans (Optional)",
    type: "number",
    gridColumn: "span 2",
    required: false,
  },
  {
    name: "churnrate",
    label: "Customer Churn Rate (%) (Optional)",
    type: "number",
    gridColumn: "span 2",
    required: false,
  },
  {
    name: "revenueperrep",
    label: "Revenue Per RO (Optional)",
    type: "number",
    gridColumn: "span 2",
    required: false,
  },
  {
    name: "clv",
    label: "Customer Lifetime Value (Optional)",
    type: "number",
    gridColumn: "span 2",
    required: false,
  },
  {
    name: "rpr",
    label: "Repeat Purchase Rate % (Optional)",
    type: "number",
    gridColumn: "span 2",
    required: false,
  },
  {
    name: "StartDate",
    label: "Start Date",
    type: "date",
    gridColumn: "span 1",
    required: true,
  },
  {
    name: "EndDate",
    label: "End Date",
    type: "date",
    gridColumn: "span 1",
    required: true,
  },
];
